import type { ReactElement } from 'react';
import { AdminCardErrorBoundary } from './admin-card-error-boundary';
import { AdminOverviewStatsRow } from './admin-overview-stats-row';
import { AdminQueuePreviewCard } from './admin-queue-preview-card';
import { AdminRecentActivityCard } from './admin-recent-activity-card';
import { AdminSystemHealthRow } from './admin-system-health-row';

export function AdminOverviewBody(): ReactElement {
  return (
    <div className="px-8 py-6 flex flex-col gap-6 max-w-[1280px] mx-auto w-full">
      <AdminCardErrorBoundary cardLabel="overview stats">
        <AdminOverviewStatsRow />
      </AdminCardErrorBoundary>
      <AdminCardErrorBoundary cardLabel="moderation queue">
        <AdminQueuePreviewCard />
      </AdminCardErrorBoundary>
      <AdminCardErrorBoundary cardLabel="recent activity">
        <AdminRecentActivityCard />
      </AdminCardErrorBoundary>
      <AdminCardErrorBoundary cardLabel="system health">
        <AdminSystemHealthRow />
      </AdminCardErrorBoundary>
    </div>
  );
}
